import React from 'react'
import PropTypes from 'prop-types'
//import { Splide, SplideSlide } from '@splidejs/react-splide'
//import '@splidejs/splide/dist/css/themes/splide-default.min.css'
import './styles.scss'
import Slider from './Slider'

class NewcomerProductSlider extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeFilter: null,
      activeFilterClass: 'active-filter',
    }
    this.setFilter = this.setFilter.bind(this)
  }

  setFilter(filter) {
    this.setState({ activeFilter: filter }, () => {
      if (this.splide) {
        this.splide.go(0)
      }
    })
  }

  render() {
    const { slides, isMD, isSM, filters } = this.props
    const { activeFilter, activeFilterClass } = this.state

    const buttons = [
      <button
        key="all"
        className={activeFilter === null ? activeFilterClass : ''}
        onClick={() => {
          this.setFilter(null)
        }}
      >
        Alle
      </button>,
      filters.length > 0 &&
        filters.map((item, i) => {
          const categoryName = item.name
          return (
            <button
              key={`${i}`}
              className={activeFilter === categoryName ? activeFilterClass : ''}
              onClick={() => {
                this.setFilter(categoryName)
              }}
            >
              {categoryName}
            </button>
          )
        }),
    ]

    return (
      <div className={`dhsv_newcomer_product_slider`}>
        <div className="filter">{buttons}</div>
        <Slider
          slides={slides}
          activeFilter={activeFilter}
          isMD={isMD}
          isSM={isSM}
        />
      </div>
    )
  }
}

NewcomerProductSlider.propTypes = {
  slides: PropTypes.array.isRequired,
  filters: PropTypes.array,
  isMD: PropTypes.bool,
  isSM: PropTypes.bool,
}

export default NewcomerProductSlider
